const Modal = (function () {
    const modal = document.querySelector('.modal');
    const modalClose = document.querySelector('.modal__close');
    const modalOverlay = document.querySelector('.modal__overlay');
    const modalMessage = document.querySelector('.modal__text');

    const closeModal = () => {
        modal.classList.remove('active');
    }

    const openModal = (message) => {
        modalMessage.textContent = '';
        modal.classList.add('active');
        modalMessage.textContent = String(message);
        setTimeout(closeModal, 3000);
    }

    const initModal = () => {
        modalClose.addEventListener('click', closeModal);
        modalOverlay.addEventListener('click', closeModal);
    };

    return {
        open: (message) => openModal(message),
        init: () => modal && initModal(),
    };
})();

export default Modal;